import './assets/report-action-guide.scss';
import './assets/step-two-guide.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { OnboardingActionGuideRuntime } from './services/onboarding-action-guide-runtime';
import { OnboardingActionGuideRuntimeImpl } from './services/impls/onboarding-action-guide-runtime';
import { OnboardingActionGuideService } from './services/onboarding-action-guide-service';
import { OnboardingActionGuideServiceImpl } from './services/impls/onboarding-action-guide-service';
import { OnboardingEligibilityService } from './services/onboarding-eligibility-service';
import { OnboardingEligibilityServiceImpl } from './services/impls/onboarding-eligibility-service';
import { OnboardingBrowserRuntime } from './services/onboarding-browser-runtime';
import { OnboardingBrowserRuntimeImpl } from './services/impls/onboarding-browser-runtime';
import { OnboardingInputExampleGuidePresenter } from './services/onboarding-input-example-guide-presenter';
import { OnboardingInputExampleGuidePresenterImpl } from './services/impls/onboarding-input-example-guide-presenter';
import { OnboardingStateService } from './services/onboarding-state-service';
import { OnboardingStateServiceImpl } from './services/impls/onboarding-state-service';
import { ReportActionGuideBubblePresenter } from './services/report-action-guide-bubble-presenter';
import { ReportActionGuideBubblePresenterImpl } from './services/impls/report-action-guide-bubble-presenter';
import { OnboardingStepTwoGuideService } from './services/onboarding-step-two-guide-service';
import { OnboardingStepTwoGuideServiceImpl } from './services/impls/onboarding-step-two-guide-service';

/** 注册首次引导公共 API 和 service。 */
export const onboardingCommonModule = (bind: interfaces.Bind) => {
    bind(OnboardingActionGuideRuntime).to(OnboardingActionGuideRuntimeImpl);
    bind(OnboardingActionGuideService).to(OnboardingActionGuideServiceImpl);
    bind(OnboardingEligibilityService).to(OnboardingEligibilityServiceImpl).inSingletonScope();
    bind(OnboardingStateService).to(OnboardingStateServiceImpl).inSingletonScope();
    bind(OnboardingBrowserRuntime).to(OnboardingBrowserRuntimeImpl);
    bind(OnboardingInputExampleGuidePresenter).to(OnboardingInputExampleGuidePresenterImpl);
    bind(ReportActionGuideBubblePresenter).to(ReportActionGuideBubblePresenterImpl);
    bind(OnboardingStepTwoGuideService).to(OnboardingStepTwoGuideServiceImpl).inSingletonScope();
};

export { OnboardingActionGuideRuntime } from './services/onboarding-action-guide-runtime';
export { OnboardingActionGuideRuntimeImpl } from './services/impls/onboarding-action-guide-runtime';
export { OnboardingActionGuideService } from './services/onboarding-action-guide-service';
export { OnboardingActionGuideServiceImpl } from './services/impls/onboarding-action-guide-service';
export { OnboardingEligibilityService } from './services/onboarding-eligibility-service';
export { OnboardingEligibilityServiceImpl } from './services/impls/onboarding-eligibility-service';
export { OnboardingStateService } from './services/onboarding-state-service';
export { OnboardingStateServiceImpl } from './services/impls/onboarding-state-service';
export { OnboardingBrowserRuntime } from './services/onboarding-browser-runtime';
export { OnboardingBrowserRuntimeImpl } from './services/impls/onboarding-browser-runtime';
export { OnboardingInputExampleGuidePresenter } from './services/onboarding-input-example-guide-presenter';
export { OnboardingInputExampleGuidePresenterImpl } from './services/impls/onboarding-input-example-guide-presenter';
export { ReportActionGuideBubblePresenter } from './services/report-action-guide-bubble-presenter';
export { ReportActionGuideBubblePresenterImpl } from './services/impls/report-action-guide-bubble-presenter';
export { OnboardingStepTwoGuideService } from './services/onboarding-step-two-guide-service';
export { OnboardingStepTwoGuideServiceImpl } from './services/impls/onboarding-step-two-guide-service';
export type {
    OnboardingStepTwoAgent,
} from './services/onboarding-step-two-guide-service';
export { registerOnboardingLocaleMessages } from './utils/onboarding-locale';
export { createReportCanvasPlacementTracker } from './utils/report-canvas-placement';
export type {
    ReportCanvasPlacement,
    ReportCanvasPlacementTracker,
} from './utils/report-canvas-placement';
export type {
    OnboardingInputExampleGuideMode,
    OnboardingInputExampleGuideShowOptions,
} from './services/onboarding-input-example-guide-presenter';
export type {
    ReportActionGuideBubbleShowOptions,
} from './services/report-action-guide-bubble-presenter';
